/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ConfirmAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function ConfirmAction({
  children,
  viewPath = "/DesignSystem/AppsLauncherProperties/ConfirmAction",
  onSubmit,
  disabled
  
}) {
let stepsSubmitData = fromData.useDataSubmit({ viewPath,
context: 'steps',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 size="normal"
 type="primary"
 marginLeft={dtSpaceXs}
 data="steps"
 onClick={stepsSubmitData}
 disabled={disabled}
 text="Confirm"
/>
{children}
</React.Fragment>)
}